import { render, staticRenderFns } from "./LgameNavBarUserCard.vue?vue&type=template&id=578e4052&scoped=true&"
import script from "./LgameNavBarUserCard.vue?vue&type=script&lang=js&"
export * from "./LgameNavBarUserCard.vue?vue&type=script&lang=js&"
import style0 from "./LgameNavBarUserCard.vue?vue&type=style&index=0&id=578e4052&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e4052",
  null
  
)

export default component.exports